/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReplaceUiSettingsRequestBody
 */
export interface ReplaceUiSettingsRequestBody {
    /**
     * 
     * @type {string}
     * @memberof ReplaceUiSettingsRequestBody
     */
    json: string;
}

/**
 * Check if a given object implements the ReplaceUiSettingsRequestBody interface.
 */
export function instanceOfReplaceUiSettingsRequestBody(value: object): value is ReplaceUiSettingsRequestBody {
    if (!('json' in value) || value['json'] === undefined) return false;
    return true;
}

export function ReplaceUiSettingsRequestBodyFromJSON(json: any): ReplaceUiSettingsRequestBody {
    return ReplaceUiSettingsRequestBodyFromJSONTyped(json, false);
}

export function ReplaceUiSettingsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplaceUiSettingsRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'json': json['json'],
    };
}

export function ReplaceUiSettingsRequestBodyToJSON(json: any): ReplaceUiSettingsRequestBody {
    return ReplaceUiSettingsRequestBodyToJSONTyped(json, false);
}

export function ReplaceUiSettingsRequestBodyToJSONTyped(value?: ReplaceUiSettingsRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'json': value['json'],
    };
}

